import React from 'react'
import TestSuccess from '../Components/TestSuccess/TestSuccess'

const TestSuccesView = () => {
  return (
    <div>
        <TestSuccess />
    </div>
  )
}

export default TestSuccesView